"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectTimestamps = exports.selectLoaderText = exports.selectIsLoading = exports.selectIsGuidedSellingModalOpen = exports.selectIsCheckoutInProgress = exports.selectHasError = exports.selectCurrentPage = exports.selectCurrentModalSize = exports.selectCurrentDynamicPage = void 0;
var selectIsLoading = function selectIsLoading(state) {
  return state.drools.ui.isLoading === true;
};
exports.selectIsLoading = selectIsLoading;
var selectLoaderText = function selectLoaderText(state) {
  return state.drools.ui.loaderText;
};
exports.selectLoaderText = selectLoaderText;
var selectCurrentPage = function selectCurrentPage(state) {
  return state.drools.ui.currentPage;
};
exports.selectCurrentPage = selectCurrentPage;
var selectHasError = function selectHasError(state) {
  return state.drools.ui.error;
};
exports.selectHasError = selectHasError;
var selectIsGuidedSellingModalOpen = function selectIsGuidedSellingModalOpen(state) {
  return state.drools.ui.isGuidedSellingModalOpen;
};
exports.selectIsGuidedSellingModalOpen = selectIsGuidedSellingModalOpen;
var selectIsCheckoutInProgress = function selectIsCheckoutInProgress(state) {
  return state.drools.ui.isCheckoutInProgress;
};
exports.selectIsCheckoutInProgress = selectIsCheckoutInProgress;
var selectTimestamps = function selectTimestamps(state) {
  return state.drools.ui.timestamps;
};
exports.selectTimestamps = selectTimestamps;
var selectCurrentModalSize = function selectCurrentModalSize(state) {
  return state.drools.ui.currentModalSize;
};
exports.selectCurrentModalSize = selectCurrentModalSize;
var selectCurrentDynamicPage = function selectCurrentDynamicPage(state) {
  return state.drools.ui.currentDynamicPage;
};
exports.selectCurrentDynamicPage = selectCurrentDynamicPage;